import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`GraphQL`}</h2>
    <p>{`C’est le chef d’orchestre vif comme l'éclair de vos API, c’est-à-dire des données nécessaires au fonctionnement dynamique de vos applications. Les anciennes méthodes vont bientôt prendre la poussière.
Facebook, Twitter, PayPal, Shopify, Allociné, ça vous parle ?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      